import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

const pageStyle = css({
  minHeight: '100dvh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  boxSizing: 'border-box',
  textAlign: 'center',
  backgroundColor: theme.colors.neutral5,
});

export const NotFoundPageContent: FC = () => {
  const { t } = useTranslation('digital-forms-experience');

  return (
    <section css={pageStyle}>
      <Heading level={2}>{t('404')}</Heading> | <Text as='span'>{t('This page could not be found.')}</Text>
    </section>
  );
};
